export default __webpack_public_path__ + "static/media/vector_down.25d8949e.svg";